

import React from 'react';
import { Form, Input, Spin, Button } from 'antd';

const onFinish = (props, values, history) => {
  const { loginUser, location } = props;

  loginUser(values).then(() => {
    const { state } = location || {};
    const { redirectUrl } = state || {};
    redirectUrl && history.push(redirectUrl);
  });
};

const onFinishFailed = (errorInfo) => {
  console.log('Failed:', errorInfo);
};

const Login = (props) => {
  const { history, loading } = props;
  const [form] = Form.useForm();
  return (
    <div>
      <section className="sign-up-page login-page">
        <div className="container">
          <div className="row">
            <div className="col-xl-7 col-lg-8 col-md-12 mx-auto">
              <div className="row">
                <div className="col-lg-6 col-md-7">
                  <div className="form-wraper">
                    <h3 className="text-center">Welcome at iCause</h3>
                    <p className="text-center">Login to your Account</p>
                    <Spin spinning={loading}>
                      <Form
                        form={form}
                        layout="vertical"
                        name="basic"
                        onFinish={(values) => onFinish(props, values, history)}
                        onFinishFailed={onFinishFailed}
                      >
                        <div className="form-group">
                          <Form.Item
                            label='Type Username or Email'
                            name="userNameOrEmail"
                            rules={[
                              {
                                required: true,
                                message: 'Please input username/email !',
                              },
                            ]}>
                            <Input className="form-control" placeholder='Username or Email' />
                          </Form.Item>
                          {/* <input type="text" className="form-control" placeholder="Username or Email" /> <span className="input-group-text"><i className="fa fa-facebook"></i></span> */}
                        </div>
                        <div className="form-group">
                          <Form.Item
                            label='Password'
                            name="password"
                            rules={[
                              {
                                required: true,
                                message: 'Please input password !',
                              },
                            ]}>
                            <Input type='password' className="form-control" placeholder='Type your password' />
                          </Form.Item>
                          {/* <input type="text" className="form-control" placeholder="Type you password" /> <span className="input-group-text"><i className="fa fa-facebook"></i></span> */}
                        </div>
                        <Form.Item>
                          <button className="btn btn-success   text-uppercase mt-4 d-block w-100" type="submit">LOGIN</button>
                        </Form.Item>
                        <p className="text-center my-text mt-3">Don't have an Account?
                      <span className="text-grn">
                            <Button style={{ marginLeft: '30px', paddingTop: '8px' }} type='link' onClick={() => history.push('/auth/signup')}>
                              Sign up
                        </Button>
                          </span>
                        </p>
                      </Form>
                    </Spin>
                  </div>
                </div>
                <div className=" col-lg-6 col-md-5">
                  <div className="social-button">
                    <div className="btn-wrper mt-3">
                      <button type="button" className="btn btn-primary bg">Sign in with Facebook</button> <span className="btn-icon"><img src="/images/fb-icon.png" className="img-fluid" alt="" /></span></div>
                    <div className="btn-wrper mt-2">
                      <button type="button" className="btn btn-primary bg-2">Sign in with Google</button><span className="btn-icon"><img src="/images/google-icon.png" className="img-fluid" alt="" /> </span></div>
                    <div className="text-mob"> <span className="after-line">OR</span> </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Login;
